import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    Expander,
    ExpanderTheme,
    ExpanderButtonStyle,
    ExpanderBorderStyle,
    Panel,
    PanelTheme,
    ExpanderExpandedHeaderTheme,
    PanelBorderStyle,
    PanelBorderRadius,
} from '@apply/components';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ExpanderDemo: React.FC<{}> = ({}) => {
    const handleButtonCiick: React.MouseEventHandler = useCallback(() => {
        alert('Expander button clicked!');
    }, []);

    const renderCustomIconExpanderHeader = (icon: IconDefinition, iconColor: string, text: string) => {
        return (
            <>
                <FontAwesomeIcon
                    icon={icon}
                    style={{ paddingRight: '10px', color: `${iconColor}`, paddingTop: '3px' }}
                />
                <h3>{text}</h3>
            </>
        );
    };

    const renderCustomCountExpanderHeader = (count: number, text: string) => {
        return (
            <>
                <h3>
                    <span style={{ color: '#112CA0', paddingRight: '10px', paddingTop: '3px' }}>({count})</span>
                    {text}
                </h3>
            </>
        );
    };

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Expanders</li>
            <br />
            <Expander
                header={renderCustomCountExpanderHeader(3, 'Expander With Specified Height')}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Rounded}
                height='80px'
            >
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Small}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    This is panel 1
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Small}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    This is panel 2
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Small}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    This is panel 3
                </Panel>
            </Expander>
            <br />
            <Expander
                header={renderCustomCountExpanderHeader(3, 'Open Items')}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Rounded}
            >
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Small}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    This is panel 1
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Small}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    This is panel 2
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Small}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    This is panel 3
                </Panel>
            </Expander>
            <br />
            <Expander
                header={renderCustomCountExpanderHeader(1, 'Initially Expanded Panel')}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Rounded}
                initialExpanded={true}
            >
                <br />
                Important things to show below.
                <br />
                <br />
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Small}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    <li>Thing 1</li>
                    <li>Thing 2</li>
                </Panel>
            </Expander>
            <br />
            <Expander
                header={<h3>Closed Items</h3>}
                theme={ExpanderTheme.Blue}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Rounded}
                handleClick={handleButtonCiick}
            >
                <br />
                These are the children of the expander.
            </Expander>
            <br />
            <Expander
                header={renderCustomIconExpanderHeader(faExclamationTriangle, '#F93E30', 'Items of Concern')}
                theme={ExpanderTheme.Red}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Rounded}
            >
                <br />
                These are the children of the expander.
            </Expander>
            <br />
            <Expander
                width='350px'
                header={<h5>Category 1</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderStyle={ExpanderBorderStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <br />
                This is more content.
            </Expander>
            <Expander
                width='350px'
                header={<h5>Category 1</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderStyle={ExpanderBorderStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <br />
                This is more content.
            </Expander>
            <Expander
                width='350px'
                header={<h5>Category 3</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderStyle={ExpanderBorderStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <br />
                This is more content.
            </Expander>
            <Expander
                width='350px'
                header={<h5>Category 4</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderStyle={ExpanderBorderStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <br />
                This is more content.
                <br />
                <br />
                <Expander
                    height='22px'
                    header={<h5>Additional Item Expander</h5>}
                    buttonStyle={ExpanderButtonStyle.NoRounding}
                    borderStyle={ExpanderBorderStyle.Rounded}
                    theme={ExpanderTheme.Gray}
                >
                    <li>Item 1</li>
                    <li>Item 2</li>
                    <li>Item 3</li>
                </Expander>
            </Expander>
        </div>
    );
};
